import {
  ApolloClient,
  createNetworkInterface,
  createBatchingNetworkInterface,
} from "react-apollo";
import oktaClient from "app/utils/oktaClient";
import { getAuthGroups, getUserGroups } from "app/utils/authGroups";

const networkInterface = createNetworkInterface({
  uri:
    process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
    "/integration/console/graph/queries",
  opts: {
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
  },
});

const batchedNetworkInterface = createBatchingNetworkInterface({
  uri:
    process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
    "/integration/console/graph/queries",
});

const authHeaderMiddleware = (req: any, next: any) => {
  if (!req.options.headers) {
    req.options.headers = {}; // Create the header object if needed.
  }

  req.options.headers.authorization = oktaClient.getAuthorizationHeader();
  if (process.env.REACT_APP_ENV !== "PRODUCTION") {
    req.options.headers["x-Auth-Groups-Override"] = localStorage.getItem(
      "devAuth"
    )
      ? JSON.parse(localStorage.getItem("devAuth"))
      : getAuthGroups.asArray();
  }
  req.options.headers["x-User-Groups"] = getUserGroups();
  next();
};

const errorHandlingAfterware = ({ response }: any, next: any) => {
  if (!response.ok) {
    response
      .clone()
      .text()
      .then((bodyText) => {
        alert(
          `Network Error: ${response.status} (${response.statusText}) - ${bodyText}`
        );
        next();
      });
  } else {
    response
      .clone()
      .json()
      .then(({ errors }) => {
        if (errors && process.env.REACT_APP_ENV !== "PRODUCTION") {
          console.log("GraphQL Errors: \n" + errors.map((e) => e.message));
        }
        next();
      });
  }
};

networkInterface.use([
  {
    applyMiddleware: authHeaderMiddleware,
  },
]);
networkInterface.useAfter([{ applyAfterware: errorHandlingAfterware }]);

batchedNetworkInterface.use([
  {
    applyBatchMiddleware: authHeaderMiddleware,
  },
]);

const apolloClient = new ApolloClient({
  networkInterface,
});

const batchedApolloClient = new ApolloClient({
  networkInterface: batchedNetworkInterface,
});

export { apolloClient, batchedApolloClient };
